export default __webpack_public_path__ + "static/media/clock.c63abd5a.svg";